import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import Alert from "./../../common/alert/Alert";
import { Row, Col, FormGroup, FormLabel, FormControl, FormCheck } from "react-bootstrap";
import AppModal from "../../common/modal/AppModal";
import { Typeahead } from "react-bootstrap-typeahead";
import {
  ID_PREFIX_RICH_MARK,
  ID_PREFIX_SORTABLE_BOX,
  ID_PREFIX_CONTAINED_VIEW,
  PAGE_TYPES,
  ID_PREFIX_PAGE,
  ID_PREFIX_BOX,
} from "../../../../common/constants";
import i18n from "i18next";
import { isSection, isContainedView, nextAvailName } from "../../../../common/utils";
import "./_richMarksModal.scss";
import IdealStudio from "../../../../core/editor/main";

import TemplatesModalRich from "../templates_modal/TemplatesModalRich";
import { createBox } from "../../../../common/common_tools";
import ColorPicker from "../../common/color-picker/ColorPicker";

/**
 * Modal component to edit marks' configuration
 */
export default class RichMarksModal extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    /**
     * Component's initial state
     * @type {{connectMode: string, displayMode: string, newSelected: string, existingSelected: string, newType: string, viewNames: *, showAlert: boolean}}
     */
    this.state = {
      connectMode: "new",
      displayMode: "navigate",
      newSelected: this.props.navItems[this.props.navItemSelected]
        ? this.props.navItems[this.props.navItemSelected].type
        : "",
      existingSelected: "",
      newType: PAGE_TYPES.SLIDE,
      viewNames: this.returnAllViews(this.props),
      showAlert: false,
      showTemplates: false,
      boxes: [],
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleTemplatesModal = this.toggleTemplatesModal.bind(this);
    this.templateClick = this.templateClick.bind(this);
    this.titleRef = React.createRef();
    this.externalSelectedRef = React.createRef();
    this.popupSelectedRef = React.createRef();
    this.valueRef = React.createRef();
  }

  /**
   * Before component receives props
   * Updates component's state with toolbar's state info
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {
    let current = nextProps.currentRichMark;
    let allViews = this.returnAllViews(nextProps);
    let currentViewType =
      this.props.containedViewSelected === 0
        ? this.props.navItems[this.props.navItemSelected].type
        : this.props.containedViews[this.props.containedViewSelected].type;
    if (!this.props.visible) {
      if (current) {
        this.setState({
          viewNames: allViews,
          color: current.color,
          connectMode: current.connectMode || "new",
          displayMode: current.displayMode || "navigate",
          newSelected: current.connectMode === "new" ? current.connection : "",
          newType: nextProps.navItems[nextProps.navItemSelected]
            ? nextProps.navItems[nextProps.navItemSelected].type
            : "",
          existingSelected:
            current.connectMode === "existing" &&
            this.remapInObject(nextProps.navItems, nextProps.containedViews)[current.connection]
              ? this.remapInObject(nextProps.navItems, nextProps.containedViews)[current.connection]
                  .id
              : "",
        });
      } else {
        this.setState({
          viewNames: allViews,
          color: null,
          connectMode: "new",
          displayMode: "navigate",
          newSelected: "",
          newType: nextProps.navItems[nextProps.navItemSelected]
            ? nextProps.navItems[nextProps.navItemSelected].type
            : "",
          existingSelected: "",
        });
      }
    }
  }

  /**
   * Render React Component
   * @returns {code}
   */
  render() {
    let richMarkValue = null;
    let marksType =
      this.props.pluginToolbar &&
      this.props.pluginToolbar.pluginId &&
      IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId) &&
      IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId).getConfig() &&
      IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId).getConfig().marksType
        ? IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId).getConfig().marksType
        : {};
    function getRichMarkInput(value) {
      richMarkValue = value;
    }
    let current = this.props.currentRichMark;
    let selected =
      this.state.existingSelected &&
      (this.props.containedViews[this.state.existingSelected] ||
        this.props.navItems[this.state.existingSelected])
        ? isContainedView(this.state.existingSelected)
          ? {
              label: this.props.containedViews[this.state.existingSelected].name,
              id: this.state.existingSelected,
            }
          : {
              label: this.props.navItems[this.state.existingSelected].name,
              id: this.state.existingSelected,
            }
        : this.returnAllViews(this.props)[0] || [];
    let newSelected = "";
    if (this.props.viewToolbars[this.state.newSelected] !== undefined) {
      newSelected = this.props.viewToolbars[this.state.newSelected].viewName;
    }
    let currentNavItemType = this.props.navItems[this.props.navItemSelected].type;
    let plugin =
      this.props.pluginToolbar &&
      this.props.pluginToolbar.pluginId &&
      IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId)
        ? IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId)
        : undefined;
    let defaultMarkValue = plugin
      ? IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId).getDefaultMarkValue(
          this.props.pluginToolbar.state,
          this.props.boxSelected
        )
      : "";
    let pluginType =
      this.props.pluginToolbar && this.props.pluginToolbar.config
        ? this.props.pluginToolbar.config.displayName
        : "Plugin";
    let config = plugin ? plugin.getConfig() : null;
    let newId = "";
    const handleCancel = () => {
      this.props.onRichMarksModalToggled();
      this.restoreDefaultTemplate();
    };

    const footer = (
      <div className="app-modal__footer">
        <button
          type="button"
          className="app-modal__btn app-modal__btn--ghost"
          onClick={handleCancel}
        >
          {i18n.t("Cancel")}
        </button>
        <button
          type="button"
          className="app-modal__btn app-modal__btn--primary"
          onClick={() => {
            let title = this.titleRef.current.value;
            newId = ID_PREFIX_CONTAINED_VIEW + Date.now();
            let newMark = current && current.id ? current.id : ID_PREFIX_RICH_MARK + Date.now();
            let connectMode = this.state.connectMode;
            let color = this.state.color || marksType.defaultColor || "#222222";
            let connection = selected.id;
            let name =
              connectMode === "existing"
                ? this.props.viewToolbars[connection].viewName
                : nextAvailName(i18n.t("contained_view"), this.props.viewToolbars, "viewName");
            title = title || nextAvailName(i18n.t("marks.new_mark"), this.props.marks, "title");
            let markState;
            let value = this.valueRef.current.value;
            if (plugin && plugin.validateValueInput) {
              let val = plugin.validateValueInput(value);
              if (val && val.isWrong) {
                this.setState({
                  showAlert: true,
                  alertMsg: val.message ? val.message : i18n.t("mark_input"),
                });
                return;
              } else if (val && val.value) {
                value = val.value;
              }
            }
            let sortable_id = ID_PREFIX_SORTABLE_BOX + Date.now();
            switch (connectMode) {
              case "new":
                markState = {
                  mark: {
                    id: newMark,
                    origin: this.props.boxSelected,
                    title,
                    connection: newId,
                    color,
                    connectMode,
                    displayMode: this.state.displayMode,
                    value,
                  },
                  view: {
                    info: "new",
                    type: this.state.newType,
                    id: newId,
                    parent: { [newMark]: this.props.boxSelected },
                    boxes: this.state.newType === "document" ? [sortable_id] : [],
                    extraFiles: {},
                  },
                  viewToolbar: {
                    id: newId,
                    doc_type: this.state.newType,
                    viewName: name,
                    hideTitles: this.state.boxes.length > 0,
                  },
                };
                break;
              case "existing":
                markState = {
                  mark: {
                    id: newMark,
                    origin: this.props.boxSelected,
                    title,
                    connection,
                    color,
                    connectMode,
                    displayMode: this.state.displayMode,
                    value,
                  },
                  view: {
                    info: "new",
                    type: this.state.newType,
                    id: newId,
                    parent: this.props.boxSelected,
                    name,
                    boxes: [],
                    extraFiles: {},
                  },
                };
                break;
              case "external":
                markState = {
                  mark: {
                    id: newMark,
                    origin: this.props.boxSelected,
                    title,
                    connection: this.externalSelectedRef.current.value,
                    color,
                    connectMode,
                    displayMode: this.state.displayMode,
                    value,
                  },
                };
                break;
              case "popup":
                markState = {
                  mark: {
                    id: newMark,
                    origin: this.props.boxSelected,
                    title,
                    connection: this.popupSelectedRef.current.value,
                    color,
                    connectMode,
                    displayMode: this.state.displayMode,
                    value,
                  },
                };
                break;
            }
            if (this.props.marks[newMark] === undefined) {
              this.props.onRichMarkAdded(markState.mark, markState.view, markState.viewToolbar);
            } else {
              this.props.onRichMarkUpdated(markState.mark, markState.view, markState.viewToolbar);
            }
            this.generateTemplateBoxes(this.state.boxes, newId);
            this.restoreDefaultTemplate();
            this.props.onRichMarksModalToggled();
          }}
        >
          {i18n.t("marks.save_changes")}
        </button>
      </div>
    );

    return (
      <AppModal
        className="richMarksModal"
        backdrop
        size="lg"
        show={this.props.visible}
        onClose={handleCancel}
        title={
          <>
            <i style={{ fontSize: "18px" }} className="material-icons">
              room
            </i>{" "}
            {current ? i18n.t("marks.edit_mark_to") : i18n.t("marks.add_mark_to")}
          </>
        }
        footer={footer}
      >
        <Row>
          <FormGroup>
            <Col xs={4} md={2}>
              <FormLabel>{i18n.t("marks.mark_name")}</FormLabel>
            </Col>
            <Col xs={8} md={6}>
              <FormControl
                ref={this.titleRef}
                type="text"
                defaultValue={current ? current.title : ""}
              />
              <br />
            </Col>
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <Col xs={4} md={2}>
              <FormLabel>{i18n.t("marks.mark_color")}</FormLabel>
            </Col>
            <Col xs={8} md={6}>
              <ColorPicker
                value={this.state.color || marksType.defaultColor}
                onChange={(e) => {
                  this.setState({ color: e.color });
                }}
              />
              <br />
            </Col>
          </FormGroup>
        </Row>
        <Row>
          <Col xs={4} md={2} />
          <Col xs={6} md={5}>
            <div style={{ display: this.state.newSelected === "" ? "none" : "initial" }}>
              {i18n.t("marks.hover_message")} <strong>{newSelected}</strong>
            </div>
          </Col>
        </Row>
        <Row>
          <FormGroup>
            <Col xs={4} md={2}>
              <FormLabel>{i18n.t("marks.link_to")}</FormLabel>
            </Col>
            <Col xs={5} md={3}>
              <FormCheck
                type="radio"
                value="new"
                name="connect_mode"
                id="connect_mode_new"
                checked={this.state.connectMode === "new"}
                onChange={() => {
                  this.setState({ connectMode: "new" });
                }}
                label={i18n.t("marks.new_content")}
              />
              <FormCheck
                type="radio"
                value="existing"
                name="connect_mode"
                id="connect_mode_existing"
                disabled={!this.returnAllViews(this.props).length > 0}
                checked={this.state.connectMode === "existing"}
                onChange={() => {
                  this.setState({ connectMode: "existing" });
                }}
                label={i18n.t("marks.existing_content")}
              />
              <FormCheck
                type="radio"
                value="external"
                name="connect_mode"
                id="connect_mode_external"
                checked={this.state.connectMode === "external"}
                onChange={() => {
                  this.setState({ connectMode: "external" });
                }}
                label={i18n.t("marks.external_url")}
              />
              <FormCheck
                type="radio"
                value="popup"
                name="connect_mode"
                id="connect_mode_popup"
                checked={this.state.connectMode === "popup"}
                onChange={() => {
                  this.setState({ connectMode: "popup" });
                }}
                label={i18n.t("marks.popup")}
              />
            </Col>
          </FormGroup>
          <Col xs={5} md={3}>
            <FormGroup style={{ display: this.state.connectMode === "new" ? "block" : "none" }}>
              <FormLabel
                style={{
                  display: this.state.newSelected === "" ? "initial" : "none",
                }}
              >
                {i18n.t("marks.new_content_label")}
              </FormLabel>
              {/* DOCUMENT TYPE REMOVED FOR NOW 
                <div className={"typeSelector"}>
                  <FormControl
                    as="select"
                    defaultValue={this.state.newType}
                    style={{
                      display: this.state.newSelected === "" ? "initial" : "none",
                      width: "80%",
                    }}
                    onChange={(e) => {
                      this.setState({ newType: e.nativeEvent.target.value });
                    }}
                  >
                    <option value={PAGE_TYPES.DOCUMENT}>{i18n.t("marks.new_document")}</option>
                    <option value={PAGE_TYPES.SLIDE}>{i18n.t("marks.new_slide")}</option>
                  </FormControl>

                  <Button
                    className={"templateSettingMarks"}
                    style={{ display: this.state.newType === "slide" ? "flex" : "none" }}
                    onClick={this.toggleTemplatesModal}
                  >
                    {" "}
                    <i className={"material-icons"}>settings</i>{" "}
                  </Button>
                </div> */}
              <div className={"typeSelector"}>
                <div
                  style={{
                    display: this.state.newSelected === "" ? "initial" : "none",
                    width: "80%",
                    padding: "6px 12px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    color: "#555",
                  }}
                >
                  {i18n.t("marks.new_slide")}
                </div>
              </div>
            </FormGroup>
            <FormGroup
              style={{ display: this.state.connectMode === "existing" ? "initial" : "none" }}
            >
              <FormLabel>{i18n.t("marks.existing_content_label")}</FormLabel>
              {this.state.connectMode === "existing" && (
                <FormControl
                  as="select"
                  onChange={(e) => {
                    this.setState({ existingSelected: e.target.value });
                  }}
                  style={{
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={this.props.viewToolbars[this.state.existingSelected]?.viewName}
                >
                  {this.returnAllViews(this.props).map((view) => {
                    return (
                      <option
                        selected={
                          this.props.currentRichMark
                            ? view.id == this.props.currentRichMark.connection
                            : false
                        }
                        key={view.id}
                        value={view.id}
                      >
                        {this.props.viewToolbars[view.id].viewName}
                      </option>
                    );
                  })}
                </FormControl>
              )}
            </FormGroup>

            <FormGroup
              style={{ display: this.state.connectMode === "external" ? "initial" : "none" }}
            >
              <FormLabel>{i18n.t("marks.external_url_label")}</FormLabel>
              <FormControl
                ref={this.externalSelectedRef}
                type="text"
                defaultValue={
                  current && this.state.connectMode === "external" ? current.connection : ""
                }
                placeholder="URL"
              />
            </FormGroup>
            <FormGroup style={{ display: this.state.connectMode === "popup" ? "initial" : "none" }}>
              <FormLabel>{i18n.t("marks.popup_label")}</FormLabel>
              <FormControl
                ref={this.popupSelectedRef}
                as="textarea"
                defaultValue={
                  current && this.state.connectMode === "popup" ? current.connection : ""
                }
                placeholder={i18n.t("marks.popup_placeholder")}
              />
            </FormGroup>
          </Col>
        </Row>
        {/* <FormGroup>
                            <FormLabel>Display mode</FormLabel>
                            <FormCheck 
                                   type="radio"
                                   name="display_mode"
                                   id="display_mode_navigate"
                                   checked={this.state.displayMode === "navigate"}
                                   onChange={() => {
                                        this.setState({displayMode: "navigate"});
                                   }}
                                   label="Navigate to content" />
                            <FormCheck 
                                   type="radio"
                                   name="display_mode"
                                   id="display_mode_popup"
                                   checked={this.state.displayMode === "popup"}
                                   onChange={() => {
                                        this.setState({displayMode: "popup"});
                                   }}
                                   label="Show as popup" />
                            <FormCheck 
                                   type="radio"
                                   name="display_mode"
                                   id="display_mode_new_tab"
                                   checked={this.state.displayMode === "new_tab"}
                                   disabled={this.state.connectMode !== "external"}
                                   onChange={() => {
                                        this.setState({displayMode: "new_tab"});
                                   }}
                                   label="Open in new tab" />
                        </FormGroup>*/}
        <Row>
          <FormGroup>
            {/* Input need to have certain label like richValue*/}
            <Col xs={4} md={2}>
              <FormLabel>{marksType.name ? marksType.name : i18n.t("marks.value")}</FormLabel>
              <br />
              <FormLabel style={{ color: "grey", fontWeight: "lighter", marginTop: "-5px" }}>
                {config && config.marksType && config.marksType && config.marksType.format
                  ? config.marksType.format
                  : "x,y"}
              </FormLabel>
            </Col>
            <Col xs={8} md={6}>
              <FormControl
                ref={this.valueRef}
                type={this.state.actualMarkType}
                defaultValue={
                  this.props.markCursorValue
                    ? this.props.markCursorValue
                    : current
                      ? current.value
                      : defaultMarkValue
                        ? defaultMarkValue
                        : 0
                }
              />
            </Col>
          </FormGroup>
        </Row>
        <Alert
          className="pageModal"
          show={this.state.showAlert}
          hasHeader
          title={i18n.t("marks.wrong_value")}
          closeButton
          onClose={() => {
            this.setState({ showAlert: false });
          }}
        >
          <span> {this.state.alertMsg} </span>
        </Alert>
        <TemplatesModalRich
          show={this.state.showTemplates}
          close={this.toggleTemplatesModal}
          navItems={this.props.navItems}
          boxes={this.props.boxes}
          // onNavItemAdded={(id, name, type, color, num, extra)=> {this.props.onNavItemAdded(id, name, this.getParent().id, type, this.calculatePosition(), color, num, extra);}}
          onIndexSelected={this.props.onIndexSelected}
          indexSelected={this.props.indexSelected}
          onBoxAdded={this.props.onBoxAdded}
          calculatePosition={this.calculatePosition}
          templateClick={this.templateClick}
          idSlide={newId || ""}
        />
      </AppModal>
    );
  }

  /**
   * Mapping method that joins contained views and navItems in array but excluding the ones that can't be
   * @param props Component's props
   * @returns {Array} Array of views
   */
  returnAllViews(props) {
    let viewNames = [];
    props.navItemsIds.map((id) => {
      if (id === 0) {
        return;
      }
      if (props.navItems[id].hidden) {
        return;
      }
      if (!IdealStudio.Config.sections_have_content && isSection(id)) {
        return;
      }
      // We need to turn off this requisite in case there is no more pages available and we need to link to the same page the box is in
      if (props.containedViewSelected === 0 && props.navItemSelected === id) {
        return;
      }

      viewNames.push({ label: props.navItems[id].name, id: id });
    });
    Object.keys(props.containedViews).map((cv) => {
      if (cv === 0) {
        return;
      }

      if (props.containedViewSelected === cv) {
        return;
      }
      viewNames.push({ label: props.containedViews[cv].name, id: props.containedViews[cv].id });
    });
    return viewNames;
  }

  /**
   * Method used to remap navItems and containedViews together
   * @param objects
   * @returns {*}
   */
  remapInObject(...objects) {
    return Object.assign({}, ...objects);
  }
  toggleModal(e) {
    let key = e.keyCode ? e.keyCode : e.which;
    if (key === 27 && this.props.visible) {
      this.props.onRichMarksModalToggled();
    }
  }
  /**
   * Shows/Hides the Import file modal
   */
  toggleTemplatesModal() {
    this.setState((prevState, props) => ({
      showTemplates: !prevState.showTemplates,
    }));
  }
  templateClick(boxes) {
    this.setState({
      boxes: boxes,
    });
  }

  restoreDefaultTemplate() {
    this.setState({
      boxes: [],
    });
  }

  generateTemplateBoxes(boxes, newId) {
    if (boxes.length > 0) {
      boxes.map((item, index) => {
        let position = {
          x: item.box.x,
          y: item.box.y,
          type: "absolute",
        };
        let initialParams = {
          id: ID_PREFIX_BOX + Date.now() + "_" + index,
          parent: newId,
          container: 0,
          col: 0,
          row: 0,
          width: item.box.width,
          height: item.box.height,
          position: position,
          name: item.toolbar.name,
          isDefaultPlugin: true,
          page: newId,
        };
        if (item.toolbar.text) {
          initialParams.text = item.toolbar.text;
        } else if (item.toolbar.url) {
          initialParams.url = item.toolbar.url;
        }
        createBox(
          initialParams,
          item.toolbar.name,
          true,
          this.props.onBoxAdded,
          this.props.boxes,
          item.toolbar.style
        );
      });
    }
  }

  componentDidMount() {
    window.addEventListener("keyup", this.toggleModal);
  }
  componentWillUnmount() {
    window.removeEventListener("keyup", this.toggleModal);
  }
}

RichMarksModal.propTypes = {
  /**
   * Caja seleccionada
   */
  boxSelected: PropTypes.any.isRequired,
  /**
   * Toolbar del plugin
   */
  pluginToolbar: PropTypes.object,
  /**
   * Current selected view (by ID)
   */
  navItemSelected: PropTypes.any.isRequired,
  /**
   * Selected contained view
   */
  containedViewSelected: PropTypes.any.isRequired,
  /**
   * Object containing all contained views (identified by its ID)
   */
  containedViews: PropTypes.object.isRequired,
  /**
   * Object containing all views (by id)
   */
  navItems: PropTypes.object.isRequired,
  /**
   * Indica si se muestra o oculta el modal de edición de marcas
   */
  visible: PropTypes.any.isRequired,
  /**
   * Mark currently being edited
   */
  currentRichMark: PropTypes.any,
  /**
   * Creates a new mark
   */
  onRichMarkAdded: PropTypes.func.isRequired,
  /**
   * Updates a mark
   */
  onRichMarkUpdated: PropTypes.func.isRequired,
  /**
   * Show/hide marks modal form
   */
  onRichMarksModalToggled: PropTypes.any.isRequired,
  /**
   * Cursor value when creating mark (coordinates)
   */
  markCursorValue: PropTypes.any,
  /**
   * Object containing all the marks
   */
  marks: PropTypes.object,
  /**
   * Object containing all the viewTollbars
   */
  viewToolbars: PropTypes.object,
  /**
   *  Object containing all created boxes (by id)
   */
  boxes: PropTypes.object,
  /**
   * Function for adding a new box
   */
  onBoxAdded: PropTypes.func,
  /**
   * Function for getting the id of the selected template
   */
  onIndexSelected: PropTypes.func,
  /**
   * Contains the id of the selected template
   */
  indexSelected: PropTypes.func,
};
